import axios from 'axios';
import moment from 'moment';


class MitSpacesSettingsService {
  constructor() {
  }
  get(buildingMitId) {
    return new Promise ((resolve, reject) => {
      axios.get('/api/v2/admin/spaces/buildings/'+buildingMitId+'/settings')
        .then((response) => {
            let versions = [];
            versions.push({name:'Latest', val:null});//Add a default one, which when set in the database will default queries to the latest version
            for(let x = 0; x < response.data.buildingVersions.length; x++){
                versions.push({name:response.data.buildingVersions[x], val:response.data.buildingVersions[x]})
            }
            response.data.ui = {
                versions: versions
            }
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }
  update(buildingMitId, data) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/buildings/'+buildingMitId+'/settings', data)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }
  getObjectDefinitions(activeOnly){
      return new Promise ((resolve, reject) => {
          let url = '/api/v2/user/spaces/object/types';

          if(activeOnly){
              url += '?active=true';
          }

          axios.get(url)
              .then((response) => {
                  for(let x = 0; x < response.data.definitions.length; x++){
                      response.data.definitions[x].iconPath = '/images/'+response.data.definitions[x].icon
                  }
                  return resolve(response.data);
              })
              .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
              });

      });
  }
  saveObjectDefinition(objDef){
      return new Promise ((resolve, reject) => {
          let formData = new FormData();

          if(objDef && objDef.id !== null && typeof objDef.id !== 'undefined'){
              formData.append("id", objDef.id);
          }

          formData.append("type", objDef.type.toUpperCase());
          formData.append("name", objDef.name);
          formData.append("icon", objDef.icon);
          formData.append("color", objDef.color);
          formData.append("width", objDef.width);
          formData.append("height", objDef.height);
          formData.append("active", objDef.active);
          formData.append("image", objDef.image);

          axios.post('/api/v2/admin/spaces/object/types', formData, {headers: {'Content-Type': 'multipart/form-data'} })
              .then((response) => {
                  return resolve(response.data);
              })
              .catch((error) => {
                console.log('ERROR:', error);
                return reject(error);
              });
    });
  }

  deleteTypeOverrides(id){
    return new Promise ((resolve, reject) => {
        axios.delete('/api/v2/admin/spaces/override/types/'+id)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });

    });
  }

  getTypeOverrides(){
    return new Promise ((resolve, reject) => {
        let url = '/api/v2/admin/spaces/override/types';

        axios.get(url)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });

    });
  }
  saveTypeOverride(typeModel){
    return new Promise ((resolve, reject) => {

      typeModel.overrideUseType = typeModel.overrideUseType.toUpperCase();
      typeModel.overrideUseCategory = typeModel.overrideUseCategory.toUpperCase();

        axios.post('/api/v2/admin/spaces/override/types', typeModel)
            .then((response) => {
                return resolve(response.data);
            })
            .catch((error) => {
              console.log('ERROR:', error);
              return reject(error);
            });
    });
  }


}

export default MitSpacesSettingsService;
